export default __webpack_public_path__ + "static/media/complete-form.77245007.svg";